<div class="container-fluid my-container">
    <div class="buttons my-2">
        <div> </div>
        <div class="buttons-right">
            <button style="background-color:transparent;" matTooltip="Salva" type="button" class="my-bounce btn btn-primary mx-2"
                (click)="update()">
                <mat-icon class="material-icons" style="color:#293683;">save</mat-icon>
            </button>
        </div>
    </div>
    <div class="full-w center" fxLayout="row">
        <form [formGroup]="form" class="form-container" (ngSubmit)="update()">
            <mat-expansion-panel style="margin:5px; width: 100%;">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="my-bounce material-icons">settings</span>
                        <div class="fw-bolder text-dark"> {{ 'LABEL.CONFIG_LICENCES' | translate }}</div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row g-6 g-xl-9">
                    <div class="inline-div">
                        <mat-form-field style="margin:5px; width: 140px;" appearance="fill" class="form-subject">
                            <mat-label class="lbl" *ngIf="!utentiBronze?.valid" style="color:red;"><span>{{ 'LABEL.USER_NUMB' | translate }} {{ 'OTHER.bronze' | translate }} </span>
                                <mat-icon>priority_high</mat-icon>
                            </mat-label>
                            <mat-label *ngIf="utentiBronze?.valid">{{ 'LABEL.USER_NUMB' | translate }} {{ 'OTHER.bronze' | translate }}</mat-label>
                            <input type="number" matInput [placeholder]="translate.instant('LABEL.INS_USER_NUMB')"
                                formControlName="utentiBronze">
                        </mat-form-field>
                        <mat-form-field style="margin:5px; width: 140px;" appearance="fill" class="form-subject">
                            <mat-label class="lbl" *ngIf="!utentiSilver?.valid" style="color:red;"><span>{{ 'LABEL.USER_NUMB' | translate }} {{ 'OTHER.silver' | translate }} </span>
                                <mat-icon>priority_high</mat-icon>
                            </mat-label>
                            <mat-label *ngIf="utentiSilver?.valid">{{ 'LABEL.USER_NUMB' | translate }} {{ 'OTHER.silver' | translate }}</mat-label>
                            <input type="number" matInput [placeholder]="translate.instant('LABEL.INS_USER_NUMB')"
                                formControlName="utentiSilver">
                        </mat-form-field>
                        <mat-form-field style="margin:5px; width: 140px;" appearance="fill" class="form-subject">
                            <mat-label class="lbl" *ngIf="!utentiGold?.valid" style="color:red;"><span>{{ 'LABEL.USER_NUMB' | translate }} {{ 'OTHER.gold' | translate }} </span>
                                <mat-icon>priority_high</mat-icon>
                            </mat-label>
                            <mat-label *ngIf="utentiGold?.valid">{{ 'LABEL.USER_NUMB' | translate }} {{ 'OTHER.gold' | translate }}</mat-label>
                            <input type="number" matInput [placeholder]="translate.instant('LABEL.INS_USER_NUMB')"
                                formControlName="utentiGold">
                        </mat-form-field>
                    </div>
                    <div class="inline-div">
                        <mat-form-field style="margin:5px; width: 140px;" appearance="fill" class="form-subject">
                            <mat-label class="lbl" *ngIf="!utentiBronze_l2?.valid" style="color:red;"><span>{{ 'LABEL.USER_NUMB' | translate }} {{ 'OTHER.bronze_l2' | translate }} </span>
                                <mat-icon>priority_high</mat-icon>
                            </mat-label>
                            <mat-label *ngIf="utentiBronze_l2?.valid">{{ 'LABEL.USER_NUMB' | translate }} {{ 'OTHER.bronze_l2' | translate }}</mat-label>
                            <input type="number" matInput [placeholder]="translate.instant('LABEL.INS_USER_NUMB')"
                                formControlName="utentiBronze_l2">
                        </mat-form-field>
                        <mat-form-field style="margin:5px; width: 140px;" appearance="fill" class="form-subject">
                            <mat-label class="lbl" *ngIf="!utentiSilver_l2?.valid" style="color:red;"><span>{{ 'LABEL.USER_NUMB' | translate }} {{ 'OTHER.silver_l2' | translate }} </span>
                                <mat-icon>priority_high</mat-icon>
                            </mat-label>
                            <mat-label *ngIf="utentiSilver_l2?.valid">{{ 'LABEL.USER_NUMB' | translate }} {{ 'OTHER.silver_l2' | translate }}</mat-label>
                            <input type="number" matInput [placeholder]="translate.instant('LABEL.INS_USER_NUMB')"
                                formControlName="utentiSilver_l2">
                        </mat-form-field>
                        <mat-form-field style="margin:5px; width: 140px;" appearance="fill" class="form-subject">
                            <mat-label class="lbl" *ngIf="!utentiGold_l2?.valid" style="color:red;"><span>{{ 'LABEL.USER_NUMB' | translate }} {{ 'OTHER.gold_l2' | translate }} </span>
                                <mat-icon>priority_high</mat-icon>
                            </mat-label>
                            <mat-label *ngIf="utentiGold_l2?.valid">{{ 'LABEL.USER_NUMB' | translate }} {{ 'OTHER.gold_l2' | translate }}</mat-label>
                            <input type="number" matInput [placeholder]="translate.instant('LABEL.INS_USER_NUMB')"
                                formControlName="utentiGold_l2">
                        </mat-form-field>
                    </div>
                    <hr>
                    <div class="inline-div">
                        <mat-form-field style="margin:5px; width: 140px;" appearance="fill" class="form-subject">
                            <mat-label class="lbl" *ngIf="!utentiBronze?.valid" style="color:red;"><span>{{ 'LABEL.LICENCE_COST' | translate }} {{ 'OTHER.bronze' | translate }} </span>
                                <mat-icon>priority_high</mat-icon>
                            </mat-label>
                            <mat-label *ngIf="utentiBronze?.valid">{{ 'LABEL.LICENCE_COST' | translate }} {{ 'OTHER.bronze' | translate }}</mat-label>
                            <input type="number" matInput [placeholder]="translate.instant('LABEL.COST_USER_NUMB')"
                                formControlName="costoBronze">
                        </mat-form-field>
                        <mat-form-field style="margin:5px; width: 140px;" appearance="fill" class="form-subject">
                            <mat-label class="lbl" *ngIf="!utentiSilver?.valid" style="color:red;"><span>{{ 'LABEL.LICENCE_COST' | translate }} {{ 'OTHER.silver' | translate }} </span>
                                <mat-icon>priority_high</mat-icon>
                            </mat-label>
                            <mat-label *ngIf="utentiSilver?.valid">{{ 'LABEL.LICENCE_COST' | translate }} {{ 'OTHER.silver' | translate }}</mat-label>
                            <input type="number" matInput [placeholder]="translate.instant('LABEL.COST_USER_NUMB')"
                                formControlName="costoSilver">
                        </mat-form-field>
                        <mat-form-field style="margin:5px; width: 140px;" appearance="fill" class="form-subject">
                            <mat-label class="lbl" *ngIf="!utentiGold?.valid" style="color:red;"><span>{{ 'LABEL.LICENCE_COST' | translate }} {{ 'OTHER.gold' | translate }} </span>
                                <mat-icon>priority_high</mat-icon>
                            </mat-label>
                            <mat-label *ngIf="utentiGold?.valid">{{ 'LABEL.LICENCE_COST' | translate }} {{ 'OTHER.gold' | translate }}</mat-label>
                            <input type="number" matInput [placeholder]="translate.instant('LABEL.COST_USER_NUMB')"
                                formControlName="costoGold">
                        </mat-form-field>
                    </div>
                    <div class="inline-div">
                        <mat-form-field style="margin:5px; width: 140px;" appearance="fill" class="form-subject">
                            <mat-label class="lbl" *ngIf="!utentiBronze_l2?.valid" style="color:red;"><span>{{ 'LABEL.LICENCE_COST' | translate }} {{ 'OTHER.bronze_l2' | translate }} </span>
                                <mat-icon>priority_high</mat-icon>
                            </mat-label>
                            <mat-label *ngIf="utentiBronze_l2?.valid">{{ 'LABEL.LICENCE_COST' | translate }} {{ 'OTHER.bronze_l2' | translate }}</mat-label>
                            <input type="number" matInput [placeholder]="translate.instant('LABEL.COST_USER_NUMB')"
                                formControlName="costoBronze_l2">
                        </mat-form-field>
                        <mat-form-field style="margin:5px; width: 140px;" appearance="fill" class="form-subject">
                            <mat-label class="lbl" *ngIf="!utentiSilver_l2?.valid" style="color:red;"><span>{{ 'LABEL.LICENCE_COST' | translate }} {{ 'OTHER.silver_l2' | translate }} </span>
                                <mat-icon>priority_high</mat-icon>
                            </mat-label>
                            <mat-label *ngIf="utentiSilver_l2?.valid">{{ 'LABEL.LICENCE_COST' | translate }} {{ 'OTHER.silver_l2' | translate }}</mat-label>
                            <input type="number" matInput [placeholder]="translate.instant('LABEL.COST_USER_NUMB')"
                                formControlName="costoSilver_l2">
                        </mat-form-field>
                        <mat-form-field style="margin:5px; width: 140px;" appearance="fill" class="form-subject">
                            <mat-label class="lbl" *ngIf="!utentiGold_l2?.valid" style="color:red;"><span>{{ 'LABEL.LICENCE_COST' | translate }} {{ 'OTHER.gold_l2' | translate }} </span>
                                <mat-icon>priority_high</mat-icon>
                            </mat-label>
                            <mat-label *ngIf="utentiGold_l2?.valid">{{ 'LABEL.LICENCE_COST' | translate }} {{ 'OTHER.gold_l2' | translate }}</mat-label>
                            <input type="number" matInput [placeholder]="translate.instant('LABEL.COST_USER_NUMB')"
                                formControlName="costoGold_l2">
                        </mat-form-field>
                    </div>
                </div>
            </mat-expansion-panel>
            <br>
            <mat-expansion-panel style="margin:5px; width: 100%;" #configExpansionPanel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="my-bounce material-icons">settings</span>
                        <div class="fw-bolder text-dark"> {{ 'GEN_CONFIG.PREVENTIVE_CONFIG' | translate }}</div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <br>
                <div class="row g-6 g-xl-9">

                    <mat-expansion-panel style="margin:5px; background-color: rgb(234, 241, 242);" #configInnerExpansionPanel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <span class="material-icons-outlined">calculate</span>
                                <div class="fw-bolder text-dark"> {{ 'GEN_CONFIG.BRANCH_CAT_PHASES' | translate }}</div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <mat-tab-group class="wbck" animationDuration="300ms" #configTabGroup>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon class="material-icons">dynamic_feed</mat-icon>
                                    <span class="ml-1">{{ 'GEN_CONFIG.COMPANIES' | translate }}</span>
                                    <i *ngIf="!(wikiService.getWikiUrl(navService.getWikiKey())==null) && wikiService.getWikiUrl(navService.getWikiKey()).length > 0"  class="crs" (click)="goToWiki()" matTooltip="AlbertWiki" class="material-icons icw">help_outline</i>
                                </ng-template>
                                <div class="noBorderMyContainer">
                                    <app-companies></app-companies>
                                </div>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon class="material-icons">dynamic_feed</mat-icon>
                                    <span class="ml-1">{{ 'GEN_CONFIG.BRANCH' | translate }}</span>
                                    <i *ngIf="!(wikiService.getWikiUrl(navService.getWikiKey())==null) && wikiService.getWikiUrl(navService.getWikiKey()).length > 0"  class="crs" (click)="goToWiki()" matTooltip="AlbertWiki" class="material-icons icw">help_outline</i>
                                </ng-template>
                                <app-branches></app-branches>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon class="material-icons">dynamic_feed</mat-icon>
                                    <span class="ml-1">{{ 'GEN_CONFIG.CATEGORIES' | translate }}</span>
                                    <i *ngIf="!(wikiService.getWikiUrl(navService.getWikiKey())==null) && wikiService.getWikiUrl(navService.getWikiKey()).length > 0"  class="crs" (click)="goToWiki()" matTooltip="AlbertWiki" class="material-icons icw">help_outline</i>
                                </ng-template>
                                <app-categories></app-categories>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon class="material-icons">dynamic_feed</mat-icon>
                                    <span class="ml-1">{{ 'GEN_CONFIG.MACRO_PHASES' | translate }}</span>
                                    <i *ngIf="!(wikiService.getWikiUrl(navService.getWikiKey())==null) && wikiService.getWikiUrl(navService.getWikiKey()).length > 0"  class="crs" (click)="goToWiki()" matTooltip="AlbertWiki" class="material-icons icw">help_outline</i>
                                </ng-template>
                                <app-macrophases></app-macrophases>
                            </mat-tab>
                            <mat-tab>
                                <ng-template mat-tab-label>
                                    <mat-icon class="material-icons">dynamic_feed</mat-icon>
                                    <span class="ml-1">{{ 'GEN_CONFIG.PHASES' | translate }}</span>
                                    <i *ngIf="!(wikiService.getWikiUrl(navService.getWikiKey())==null) && wikiService.getWikiUrl(navService.getWikiKey()).length > 0"  class="crs" (click)="goToWiki()" matTooltip="AlbertWiki" class="material-icons icw">help_outline</i>
                                </ng-template>
                                <app-phases></app-phases>
                            </mat-tab>
                        </mat-tab-group>
                    </mat-expansion-panel>

                    <mat-expansion-panel style="margin:5px; background-color: rgb(234, 241, 242);">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <span class="material-icons-outlined">calculate</span>
                                <div class="fw-bolder text-dark"> {{ 'GEN_CONFIG.CREDIT_CESSION' | translate }}</div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-taxsteps></app-taxsteps>
                    </mat-expansion-panel>
                    <mat-expansion-panel style="margin:5px; background-color: rgb(234, 241, 242);">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <span class="material-icons-outlined">calculate</span>
                                <div class="fw-bolder text-dark"> {{ 'GEN_CONFIG.CONSTANTS' | translate }}</div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                    </mat-expansion-panel>
                </div>
            </mat-expansion-panel>
            <br>
            <mat-expansion-panel style="margin:5px; width: 100%;">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="my-bounce material-icons">settings</span>
                        <div class="fw-bolder text-dark"> {{ 'GEN_CONFIG.PLANNER_CONFIG' | translate }}</div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row g-6 g-xl-9">
                    <br>
                    <mat-expansion-panel style="margin:5px; background-color: rgb(234, 241, 242);">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <span class="material-icons-outlined">calculate</span>
                                <div class="fw-bolder text-dark"> {{ 'GEN_CONFIG.CONSTANTS' | translate }}</div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>
                </div>
            </mat-expansion-panel>
            <br>
            <mat-expansion-panel style="margin:5px; width: 100%;">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="my-bounce material-icons">settings</span>
                        <div class="fw-bolder text-dark"> {{ 'GEN_CONFIG.CONSUNTIVE_CONFIG' | translate }}</div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row g-6 g-xl-9">
                    <br>
                    <app-profiles [embed]="true"></app-profiles>
                    <mat-expansion-panel style="margin:5px; background-color: rgb(234, 241, 242);">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <span class="material-icons-outlined">calculate</span>
                                <div class="fw-bolder text-dark"> {{ 'GEN_CONFIG.CONSTANTS' | translate }}</div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                    </mat-expansion-panel>
                </div>
            </mat-expansion-panel>
            <br>
            <mat-expansion-panel style="margin:5px; width: 100%;">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="my-bounce material-icons">settings</span>
                        <div class="fw-bolder text-dark"> {{ 'GEN_CONFIG.WORKFLOW_CONFIG' | translate }}</div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <br>
                <div class="row g-6 g-xl-9">
                    <mat-tab-group class="wbck" animationDuration="300ms">
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <mat-icon class="material-icons">dynamic_feed</mat-icon>
                                <span class="ml-1">{{'LABEL.StatiPratiche' | translate}}</span>
                                <i *ngIf="!(wikiService.getWikiUrl(navService.getWikiKey())==null) && wikiService.getWikiUrl(navService.getWikiKey()).length > 0"  class="crs" (click)="goToWiki()" matTooltip="AlbertWiki" class="material-icons icw">help_outline</i>
                            </ng-template>
                            <app-order-statuses></app-order-statuses>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <mat-icon class="material-icons">dynamic_feed</mat-icon>
                                <span class="ml-1">{{'LABEL.CambiStato' | translate}}</span>
                                <i *ngIf="!(wikiService.getWikiUrl(navService.getWikiKey())==null) && wikiService.getWikiUrl(navService.getWikiKey()).length > 0"  class="crs" (click)="goToWiki()" matTooltip="AlbertWiki" class="material-icons icw">help_outline</i>
                            </ng-template>
                            <app-document-workflow></app-document-workflow>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <mat-icon class="material-icons">dynamic_feed</mat-icon>
                                <span class="ml-1">{{'LABEL.TipiDocumento' | translate}}</span>
                                <i *ngIf="!(wikiService.getWikiUrl(navService.getWikiKey())==null) && wikiService.getWikiUrl(navService.getWikiKey()).length > 0"  class="crs" (click)="goToWiki()" matTooltip="AlbertWiki" class="material-icons icw">help_outline</i>
                            </ng-template>
                            <app-document-types></app-document-types>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </mat-expansion-panel>
            <br>
            <mat-expansion-panel style="margin:5px; width: 100%;">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span class="my-bounce material-icons">settings</span>
                        <div class="fw-bolder text-dark"> {{ 'GEN_CONFIG.TARGET_CONFIG' | translate }}</div>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <br>
                <div class="row g-6 g-xl-9">
                    <app-targets-list></app-targets-list>
                    <!-- <app-target-detail></app-target-detail> -->
                </div>
            </mat-expansion-panel>
            <br>
            <mat-expansion-panel style="margin:5px; width: 100%;">
              <mat-expansion-panel-header>
                  <mat-panel-title>
                      <span class="my-bounce material-icons">settings</span>
                      <div class="fw-bolder text-dark"> {{ 'GEN_CONFIG.EMAIL_SETTINGS' | translate }}</div>
                  </mat-panel-title>
              </mat-expansion-panel-header>
              <br>
              <div class="row g-6 g-xl-9">
                  <app-email-template-list></app-email-template-list>
                  <!-- <app-target-detail></app-target-detail> -->
              </div>
          </mat-expansion-panel>
        </form>
    </div>
    <div class="buttons my-2">
        <div> </div>
        <div class="buttons-right">
            <!-- <button style="background-color:transparent;" matTooltip="Salva" type="button" class="my-bounce btn btn-primary mx-2"
                (click)="update()">
                <mat-icon class="material-icons" style="color:#293683;">save</mat-icon>
            </button> -->
        </div>
    </div>
</div>
